import { eventBus } from "../../eventBus.js";
import { resizeAllPlotlyCharts } from "@/utils/plotlyResizeAll";

export default {
  data() {
    return {
      drawerOpen: false,
      rightDrawerOpen: false,
      screenWidth: window.innerWidth,
    };
  },
  computed: {
    rightSubContentStyle() {
      let width = "calc(100vw - 64px)";
      let left = "64px";
      let right = "64px";

      if (this.screenWidth >= 768) {
        if (this.drawerOpen) {
          
          width = "calc(100vw - 280px)";
          left = "280px";
        }
      }

      return {
        width: width,
        left: left,
        right: right,
      };
    },
    rightContentStyle() {
      let width = "calc(100% - 20px)";

      if (this.screenWidth >= 768) {
        if (this.rightDrawerOpen){
        width = "calc(100% - 310px)";
      }
      }

      return {
        width: width,
      };
    },
    studioSimpleSelectionWidth() {
      return "100%";
    },
    studioCreateEditWidth() {
      if (this.screenWidth >= 1400) {
        return this.rightDrawerOpen ? "92%" : "96%";
      } else if (this.screenWidth >= 1024) {
        return this.rightDrawerOpen ? "86%" : "94%";
      } else if (this.screenWidth >= 768) {
        return this.rightDrawerOpen ? "78%" : "90%";
      }
      return "100%";
    },
    studioChartWrapperStyle() {
      return {
        width: this.studioCreateEditWidth,
      };
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleDrawerStateChange(isOpen) {
      if (this.screenWidth >= 768) {
        this.drawerOpen = isOpen;
      }

      this.$nextTick(() => {
        eventBus.emit("resizeChart");
        resizeAllPlotlyCharts();
      });
    },
    handleRightDrawerStateChange(isOpen) {
      if (this.screenWidth >= 768) {
        this.rightDrawerOpen = isOpen;
        localStorage.setItem('sidebarState', isOpen ? 'true' : 'false');
        this.$forceUpdate();

        this.$nextTick(() => {
          eventBus.emit("resizeChart");
          eventBus.emit("filterDrawerToggled");
          resizeAllPlotlyCharts();
        });
      }
    },
    handleResize() {
      this.screenWidth = window.innerWidth;
    },
  },
};